(() => {
  const overlay = document.querySelector('[data-wp-video-overlay]');
  if (!overlay) return;

  const launcher = document.querySelector('[data-wp-video-launcher]');
  const dismissLauncher = document.querySelector('[data-wp-video-dismiss]');
  const video = overlay.querySelector('video');
  const poster = overlay.querySelector('[data-wp-video-poster]');
  const fallback = overlay.querySelector('[data-wp-video-fallback]');
  const closeButton = overlay.querySelector('[data-wp-video-close]');
  const pauseButton = overlay.querySelector('[data-wp-video-pause]');
  const soundButton = overlay.querySelector('[data-wp-video-sound]');
  const cta = overlay.querySelector('[data-wp-video-cta]');
  const loopVideos = document.querySelectorAll('[data-wp-video-loop]');
  const dismissKey = 'wp-video-launcher-dismissed-at';
  const dismissDuration = 7 * 24 * 60 * 60 * 1000;
  let returnFocus;

  const getDismissedAt = () => {
    try { return Number(window.localStorage.getItem(dismissKey)) || 0; }
    catch (_) { return 0; }
  };

  if (launcher && Date.now() - getDismissedAt() < dismissDuration) launcher.hidden = true;

  loopVideos.forEach((loopVideo) => {
    loopVideo.muted = true;
    loopVideo.defaultMuted = true;
    loopVideo.loop = true;
    const startLoop = () => loopVideo.play().catch(() => {});
    loopVideo.addEventListener('canplay', startLoop, { once: true });
    startLoop();
  });

  dismissLauncher?.addEventListener('click', () => {
    try { window.localStorage.setItem(dismissKey, String(Date.now())); }
    catch (_) {}
    if (launcher) launcher.hidden = true;
  });

  const close = () => {
    video.pause();
    overlay.hidden = true;
    overlay.classList.remove('is-playing', 'is-paused');
    document.documentElement.classList.remove('wp-video-overlay-open');
    returnFocus?.focus({ preventScroll: true });
  };

  const open = (trigger) => {
    returnFocus = trigger;
    const source = trigger.dataset.wpVideoSrc || '';
    const posterSource = trigger.dataset.wpVideoPoster || poster.currentSrc || poster.src;
    const title = trigger.dataset.wpVideoTitle || 'Video von Weideprofi';
    const ctaLabel = trigger.dataset.wpVideoCtaLabel || '';
    const ctaUrl = trigger.dataset.wpVideoCtaUrl || '';

    poster.src = posterSource;
    poster.alt = title;
    video.setAttribute('aria-label', title);
    overlay.hidden = false;
    overlay.classList.remove('is-playing', 'is-paused');
    overlay.classList.toggle('has-video', Boolean(source));
    fallback.hidden = Boolean(source);
    cta.hidden = !(ctaLabel && ctaUrl);
    cta.textContent = ctaLabel;
    cta.href = ctaUrl || '#';
    document.documentElement.classList.add('wp-video-overlay-open');

    if (source) {
      if (video.src !== source) {
        video.src = source;
        video.load();
      }
      video.muted = false;
      video.play().catch(() => {
        video.muted = true;
        return video.play();
      }).catch(() => {});
    }
    closeButton.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-wp-video-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }
    if (event.target === overlay || event.target.closest('[data-wp-video-close]')) close();
  });

  pauseButton.addEventListener('click', () => {
    if (video.paused) video.play().catch(() => {});
    else video.pause();
  });

  soundButton.addEventListener('click', () => {
    video.muted = !video.muted;
    soundButton.setAttribute('aria-pressed', String(!video.muted));
  });

  video.addEventListener('playing', () => {
    overlay.classList.add('is-playing');
    overlay.classList.remove('is-paused');
  });
  video.addEventListener('pause', () => overlay.classList.add('is-paused'));
  video.addEventListener('ended', () => overlay.classList.add('is-paused'));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !overlay.hidden) close();
  });
})();
